import { ALL_LANGUAGES } from '../../shop/language/constants';
import { TFunction } from 'i18next';

export const mapLanguageDropdownLabel = (
    t: TFunction,
    isMultiLanguageShopEnabled: boolean,
    selectedLanguage: string
) => {
    return isMultiLanguageShopEnabled
        ? t('menu.shop.languages.learn', {
              selectedLanguage:
                  selectedLanguage === ALL_LANGUAGES
                      ? t('allLanguages')
                      : t(`filters:language.${selectedLanguage}`, {
                            defaultValue: selectedLanguage
                        })
          })
        : selectedLanguage === ALL_LANGUAGES
        ? t('allLanguages')
        : t(`filters:language.${selectedLanguage}`, {
              defaultValue: selectedLanguage
          });
};
